import { anodum } from '@yola/ws-sdk';

const isCompositeGroup = (element) => !!element && anodum.isTag(element, 'ws-composite-group');

export default isCompositeGroup;
